import { render } from "./nosto-facet.vue?vue&type=template&id=087ac7db"
import script from "./nosto-facet.vue?vue&type=script&lang=js"
export * from "./nosto-facet.vue?vue&type=script&lang=js"

import "./nosto-facet.vue?vue&type=style&index=0&id=087ac7db&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__